module.exports = __webpack_public_path__ + "static/media/Poker.345566ab.svg";